// fadein (Intersection Observerによるじんわり表示)
document.addEventListener("DOMContentLoaded", () => {
  // 監視対象の要素を全て取得
  const elements = document.querySelectorAll(".c-amehare-fade-in");

  // Intersection Observerのオプション設定
  const options = {
    root: null, // ビューポート（画面全体）をルートとする
    rootMargin: "0px",
    threshold: 0.2, // 要素の10%が画面内に入ったら発火
  };

  /**
   * 監視対象が交差したときに実行されるコールバック関数
   */
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      // isIntersectingがtrueなら画面内に入った
      if (entry.isIntersecting) {
        // 画面内に入ったら 'is-visible' クラスを追加してアニメーション発動
        entry.target.classList.add("is-visible");

        // 一度表示されたら監視を停止する
        observer.unobserve(entry.target);
      }
    });
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, options);

  // 全要素に対して処理を実行
  elements.forEach((element) => {
    // .fv クラスを持つ要素の処理 (初期表示)
    if (element.classList.contains("fv")) {
      element.classList.add("is-visible");
      // .fv要素はObserverには登録しない
    } else {
      // .fv クラスを持たない要素のみを監視対象として登録 (スクロール表示)
      observer.observe(element);
    }
  });
});

// パララックス
// $(function () {
//   var $parallaxElement = $(".c-amehare-sec-head-img img");
//   var speed = 0.2; // 速度 (0.1〜0.9程度の値。値が小さいほど遅く動く)

//   $(window)
//     .on("scroll", function () {
//       var scrollPos = $(window).scrollTop();
//       var yPos = scrollPos * speed;

//       // CSSで定義した要素に、スクロール量に応じた移動を適用
//       $parallaxElement.css({
//         transform: "translate3d(0, " + yPos + "px, 0)",
//       });
//     })
//     .trigger("scroll"); // ページ読み込み時にも一度実行
// });

// hakkou-about
document.addEventListener("DOMContentLoaded", () => {
  const sliderContainer = document.getElementById("sliderContainer");
  const indicatorProgress = document.getElementById("indicatorProgress");
  const stepNamesContainer = document.getElementById("stepNamesContainer");
  const stepDotsContainer = document.getElementById("stepDotsContainer"); // ⭐新しいコンテナ
  const slides = sliderContainer.querySelectorAll(".slide");
  const slideCount = slides.length;
  let currentSlideIndex = 0;

  const stepNames = ["おめざめ", "ととのい", "えんじゅく"];

  /**
   * ステップ名とステップドットの生成
   */
  stepNames.forEach((name, index) => {
    // ステップ名
    const stepNameDiv = document.createElement("div");
    stepNameDiv.classList.add("step-name");
    stepNameDiv.textContent = name;
    stepNameDiv.dataset.index = index;
    stepNamesContainer.appendChild(stepNameDiv);

    // ⭐ステップドット
    const stepDotDiv = document.createElement("div");
    stepDotDiv.classList.add("step-dot");
    stepDotDiv.dataset.index = index;
    stepDotsContainer.appendChild(stepDotDiv);
  });

  const stepNameElements = stepNamesContainer.querySelectorAll(".step-name");
  const stepDotElements = stepDotsContainer.querySelectorAll(".step-dot"); // ⭐ステップドットの要素リスト

  const totalScrollHeight = sliderContainer.scrollHeight;
  const containerHeight = sliderContainer.clientHeight;
  const maxScroll = totalScrollHeight - containerHeight;
  const slideHeight = containerHeight;

  /**
   * スライドとインジケーターの更新
   */
  const updateSteps = (index) => {
    // 現在のアクティブなインデックスを更新
    currentSlideIndex = index;

    // ステップ名とドットの更新
    stepNameElements.forEach((el, i) => {
      el.classList.remove("active");
      stepDotElements[i].classList.remove("active");
      stepDotElements[i].classList.remove("passed"); // いったんリセット

      if (i === index) {
        // アクティブなステップ
        el.classList.add("active");
        stepDotElements[i].classList.add("active");
      } else if (i < index) {
        // 通過済みのステップ
        stepDotElements[i].classList.add("passed");
      }
    });
  };

  /**
   * スクロールイベントの監視
   */
  const onScroll = () => {
    const scrollAmount = sliderContainer.scrollTop;

    // ----------------------------------------------------
    // ① プログレスバーの幅を計算
    // ----------------------------------------------------
    const scrollProgressRatio = scrollAmount / maxScroll;
    const trackWidth = indicatorProgress.parentElement.clientWidth;

    // プログレスバーの終点が、最後のドットの中心を指すように調整が必要
    // 今回は、現在のスライドの終端までの進行度を使用します。

    // スクロール量に比例した幅
    const progressWidth = scrollProgressRatio * trackWidth;

    // ⭐プログレスバーの幅を更新
    indicatorProgress.style.width = `${progressWidth}px`;

    // ----------------------------------------------------
    // ② 現在表示中のスライドインデックスを判定し、ステップ名を更新
    // ----------------------------------------------------
    const newIndex = Math.round(scrollAmount / slideHeight);

    if (newIndex !== currentSlideIndex) {
      updateSteps(newIndex);
    }
  };

  // 初期化とイベントリスナーの設定
  if (stepDotElements.length > 0) {
    sliderContainer.addEventListener("scroll", onScroll, { passive: true });

    // 初回実行
    onScroll();
    updateSteps(0);
  }
});

// 背景グラデーション
(() => {
  // ===== 調整ノブ =====
  const CYCLE_SEC = 35; // 1周(ゴールド→ティール/コーラル→ラベンダ/藍)の時間
  const DPR_MAX = 1.5; // パフォーマンス（重ければ 1.5 などへ）

  const dpr = Math.min(window.devicePixelRatio || 1, DPR_MAX);
  const canvas = document.getElementById("bg");
  if (!canvas) return;

  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
  });
  renderer.setPixelRatio(dpr);
  const scene = new THREE.Scene();
  const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
  const geo = new THREE.PlaneGeometry(2, 2);

  const vert = /* glsl */ `
    varying vec2 vUv;
    void main(){ vUv = uv; gl_Position = vec4(position,1.0); }
  `;

  // パッケージ準拠の3相パレットに合わせた“縦グラデ”
  const frag = /* glsl */ `
    precision highp float;
    varying vec2 vUv;
    uniform float u_time;
    uniform vec2  u_res;

    // y(0=下,1=上)で 上(top)→中(mid)→下(bot) を補間
    vec3 grad3(vec3 top, vec3 mid, vec3 bot, float y){
      float t1 = smoothstep(0.0, 0.5, y);
      float t2 = smoothstep(0.5, 1.0, y);
      vec3 c = mix(bot, mid, t1);
      return mix(c, top, t2);
    }
    // 地平付近にやわらかい“色の帯”を足して、パッケージの雰囲気を再現
    vec3 addHorizon(vec3 base, vec3 band, float y, float center, float width, float strength){
      float w = width*0.5;
      float mask = smoothstep(center - w, center, y) * (1.0 - smoothstep(center, center + w, y));
      return mix(base, band, mask * strength);
    }
    // 乱数（軽いディザリングで帯状の階調を防ぐ）
    float rnd(vec2 p){ return fract(sin(dot(p, vec2(12.9898,78.233))) * 43758.5453); }

    // 0:ゴールド（大粒） / 1:ティール→コーラル（黒豆） / 2:ラベンダ→コーラル→藍（小粒）
    vec3 paletteColor(int key, float y){
      if (key == 0){
        // ゴールド：上=温かいベージュ → 中=サンイエロー → 下=オレンジ
        vec3 col = grad3(vec3(0.92,0.86,0.68),  // top  #EAE0AD 付近
                         vec3(0.99,0.86,0.38),  // mid  #FDDC61
                         vec3(0.97,0.64,0.22),  // bot  #F7A43A
                         y);
        // わずかに霞み
        return col;
      } else if (key == 1){
        // ティール→コーラル：上=濃紺 → 中=深いティール → 下=コーラル
        vec3 col = grad3(vec3(0.03,0.07,0.13),  // top  #081223
                         vec3(0.05,0.27,0.33),  // mid  #0D4554
                         vec3(0.84,0.42,0.38),  // bot  #D66C61
                         y);
        // 地平近くに温かい帯
        // col = addHorizon(col, vec3(0.86,0.46,0.43), y, 0.18, 0.18, 0.65);
        return col;
      } else {
        // ラベンダ→コーラル→藍：上=薄い藤色 → 中=コーラル → 下=藍
        vec3 col = grad3(vec3(0.72,0.70,0.79),  // top  #B8B3C9
                         vec3(0.89,0.60,0.63),  // mid  #E29AA1
                         vec3(0.23,0.23,0.37),  // bot  #3B3B5E
                         y);
        // col = addHorizon(col, vec3(0.92,0.58,0.62), y, 0.22, 0.22, 0.60);
        return col;
      }
    }

    void main(){
      float y = vUv.y;

      // 3相を時間でクロスフェード
      float p  = mod(u_time, ${CYCLE_SEC}.0) / ${CYCLE_SEC}.0; // 0..1
      float ph = p * 3.0;                    // 0..3
      int   a  = int(floor(ph));             // 現在のキー
      int   b  = int(mod(float(a + 1), 3.0));// 次のキー
      float f  = smoothstep(0.0, 1.0, fract(ph)); // クロスフェード

      vec3 ca = paletteColor(a, y);
      vec3 cb = paletteColor(b, y);
      vec3 col = mix(ca, cb, f);

      // 軽いガンマ調整で鮮やかさをキープ（好みで調整）
      col = pow(col, vec3(0.96));

      // ディザで階調バンディングを軽減（影響はごくわずか）
      col += (rnd(gl_FragCoord.xy) - 0.5) * 0.004;
      col = clamp(col, 0.0, 1.0);

      gl_FragColor = vec4(col, 1.0);
    }
  `;

  const mat = new THREE.ShaderMaterial({
    uniforms: {
      u_time: { value: 0 },
      u_res: { value: new THREE.Vector2() },
    },
    vertexShader: vert,
    fragmentShader: frag,
  });
  scene.add(new THREE.Mesh(geo, mat));

  function resize() {
    renderer.setSize(innerWidth, innerHeight, false);
    mat.uniforms.u_res.value.set(innerWidth, innerHeight);
  }
  addEventListener("resize", resize, { passive: true });
  resize();

  const clock = new THREE.Clock();
  renderer.setAnimationLoop(() => {
    mat.uniforms.u_time.value += clock.getDelta();
    renderer.render(scene, camera);
  });
})();
